import React from "react";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";

function OrderSettingsPage() {
  return (
    <div className="bg-gray-100 py-2 min-h-screen">
      <OrderMainNav />
      <div className="container mx-auto my-6">
        OrderSettingsPage
        <p className="mb-6">
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Molestias illum modi, at corrupti ipsa ratione ducimus.
          Accusantium, possimus? Id exercitationem quo reprehenderit veniam distinctio ipsam quas adipisci non cum consequuntur.
        </p>
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-2">Communication Methods</h2>
          <p className="mb-6">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure modi deleniti repellendus placeat, illo ullam molestiae
            temporibus optio molestias quibusdam fugit, alias, sequi tenetur numquam! Natus quisquam placeat nam accusamus.
          </p>
        </div>
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-2">Notification Settings</h2>
          <p className="mb-6">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure modi deleniti repellendus placeat, illo ullam molestiae
            temporibus optio molestias quibusdam fugit, alias, sequi tenetur numquam! Natus quisquam placeat nam accusamus.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OrderLayerBlueprint(OrderSettingsPage);
